import { render, staticRenderFns } from "./vSelfie.vue?vue&type=template&id=6416e71e&scoped=true"
import script from "./vSelfie.vue?vue&type=script&lang=js"
export * from "./vSelfie.vue?vue&type=script&lang=js"
import style0 from "./vSelfie.vue?vue&type=style&index=0&id=6416e71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6416e71e",
  null
  
)

export default component.exports